import { BaseCustomerPaymentMethodsEntity } from 'libs/shared/models/customer-payment-methods/customer-payment-methods.models'
import moment from 'moment'

export class PaymentMethodUtils {
  public static isCardExpired(paymentMethod: BaseCustomerPaymentMethodsEntity): boolean {
    const expiryDate = moment({
      year: paymentMethod.card.exp_year,
      month: paymentMethod.card.exp_month - 1,
    })
    const currentDate = moment().startOf('month')
    return expiryDate.isBefore(currentDate)
  }

  public static getFirstNonExpiredCard(
    paymentMethods: BaseCustomerPaymentMethodsEntity[],
  ): BaseCustomerPaymentMethodsEntity | undefined {
    // find the first non expired card
    return paymentMethods.find((paymentMethod) => !PaymentMethodUtils.isCardExpired(paymentMethod))
  }
}
